import { DashboardHeader } from "@/components/templates/DashboardHeader";
import { DashboardMain } from "@/components/templates/DashboardMain";
import { useDashboardUrlParams } from "@/hooks/useDashboardUrlParams";
import { useUser } from "@/hooks/useUser";
import { useUI } from "@/hooks/useUI";
import { useStore } from "@/store";
import { useEffect } from "react";

export const Dashboard = () => {
  const { currentUser } = useUser();
  const currentUserId = currentUser?.uid ?? null;
  const {
    hydrateViewMode,
  } = useUI();

  const { params, clearParams } = useDashboardUrlParams();
  const setFocusedItem = useStore((state) => state.setFocusedItem);
  const setSelectedPersona = useStore((state) => state.setSelectedPersona);
  const setSelectedOffer = useStore((state) => state.setSelectedOffer);
  const setSelectedPolicy = useStore((state) => state.setSelectedPolicy);

  useEffect(() => {
    hydrateViewMode(currentUserId);
  }, [currentUserId, hydrateViewMode]);

  useEffect(() => {
    if (!params.focusType || !params.focusId) return;
    setFocusedItem({ type: params.focusType, id: params.focusId });
    clearParams(["focusType", "focusId"]);
  }, [clearParams, params.focusId, params.focusType, setFocusedItem]);

  useEffect(() => {
    if (!params.contextType || !params.contextId) return;

    if (params.contextType === "persona") {
      setSelectedPersona(params.contextId);
    } else if (params.contextType === "offer") {
      setSelectedOffer(params.contextId);
    } else if (params.contextType === "policy") {
      setSelectedPolicy(params.contextId);
    }
    clearParams(["contextType", "contextId"]);
  }, [
    clearParams,
    params.contextId,
    params.contextType,
    setSelectedOffer,
    setSelectedPersona,
    setSelectedPolicy,
  ]);

  return (
    <div className="min-h-screen-mobile flex flex-col bg-background">
      <DashboardHeader />
      <DashboardMain />

    </div>
  );
};
